exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star-spacing--xsmall {\n  margin-right: 2px; }\n\n.star-spacing--small, .star-spacing--medium, .star-spacing--large, .star-spacing--xlarge {\n  margin-right: 8px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js??ref--2-3!./src/components/ratingStars/RatingStars.scss
// module id = 2538
// module chunks = 0